import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../i18n'
import Page from '../../common/Page'
import { Button, Tooltip } from 'antd'
import MaterialSelectWithDropDown from '../../common/MaterialSelectWithDropdown'
import {
  GenderIdentities,
  Pronouns,
  BiologicalSex,
} from '../../../consts/Profile'
import Actions from '../../../actions'
import PageCard from '../../common/PageCard'

import './GenderDetails.css'

const GenderDetails = () => {
  const dispatch = useDispatch()
  const userDetails = useSelector(state => state.profile?.userDetails)
  const [genderIdentity, setGenderIdentity] = useState(
    userDetails?.genderIdentity
  )
  const [pronoun, setPronoun] = useState(userDetails?.pronoun)
  const genderIdentityList = Object.values(GenderIdentities).map(item => {
    return { label: $t(item.text), value: item.key }
  })
  const pronounList = Object.values(Pronouns).map(item => {
    return { label: $t(item.text), value: item.key }
  })
  const isGenderDetailsLoading = useSelector(
    state => state.profile?.isGenderDetailsLoading
  )

  useEffect(() => {
    setGenderIdentity(userDetails?.genderIdentity)
    setPronoun(userDetails?.pronoun)
  }, [userDetails])

  const onSave = () => {
    dispatch(
      Actions.createAction(Actions.UPDATE_GENDER_DETAILS_REQUESTED, {
        genderIdentity: genderIdentity,
        pronoun: pronoun,
        patientId: userDetails?.id,
      })
    )
  }

  const getTooltipTitle = () => {
    return (
      <div className="tooltip">
        <div className="tooltip-title-header semi-bold">
          {$t('profile.genderDetails.moreInfoTitle')}
        </div>
        <div className="tooltip-title-body-header light">
          {$t('profile.genderDetails.moreInfoBody')}
        </div>
      </div>
    )
  }

  return (
    <PageCard enableBack={true}>
      <Page
        hideAlertBanner
        loading={isGenderDetailsLoading}
        className="gender-details-page"
        title={$t('profile.genderDetails.title')}
        subtitle={
          <div className="input-container-biosex">
            {userDetails?.sex
              ? $t('profile.genderDetails.bioSex') +
                $t(BiologicalSex[userDetails?.sex.toLowerCase()])
              : $t('profile.genderDetails.bioSexMissing')}
            <Tooltip
              title={getTooltipTitle}
              placement="bottom"
              color={'var(--color_primary_t600)'}
            >
              <i className="icon-oinfo"></i>
            </Tooltip>
          </div>
        }
      >
        <div className="input-container">
          <h2>{$t('profile.genderDetails.genderIdentity')}</h2>
          <MaterialSelectWithDropDown
            data={genderIdentityList}
            value={genderIdentity}
            onChange={value => setGenderIdentity(value)}
          />
        </div>
        <div className="input-container">
          <h2>{$t('profile.genderDetails.pronoun')}</h2>
          <MaterialSelectWithDropDown
            data={pronounList}
            value={pronoun}
            onChange={value => setPronoun(value)}
          />
        </div>
        <Button
          key="1"
          className="save-gender trackable"
          data-name="save gender"
          type="primary"
          onClick={onSave}
        >
          {$t('common.save')}
        </Button>
      </Page>
    </PageCard>
  )
}

export default GenderDetails
